"use client";
import { FmDrawer } from "@/ui-component";
import { useCallback, useMemo, useState } from "react";
import styles from "../Banner/banner.module.scss";
import { useTranslation } from "@/src/i18n/client";

interface BannerClient {
    page_rule_describe: any;
}
const BannerClient: React.FC<BannerClient> = ({ page_rule_describe }) => {
    const [conditionVisible, setConditionVisible] = useState(false);
    const toggleConditionVisible = useCallback(() => {
        setConditionVisible(!conditionVisible);
    }, [conditionVisible]);
    const { t } = useTranslation("specialSub");

    const pageRuleDescribeDom = useMemo(() => {
        return !page_rule_describe ? null : (
            <div className={styles["terms-condition"]}>
                <u onClick={toggleConditionVisible}>
                    {t("specialSub:TermsConditions")} &gt;
                </u>
            </div>
        );
    }, [page_rule_describe, t, toggleConditionVisible]);

    return (
        <>
            {pageRuleDescribeDom}
            <FmDrawer
                anchor={"bottom"}
                closeablePosition="right"
                closeable
                headerChildren
                open={conditionVisible}
                onClose={toggleConditionVisible}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: page_rule_describe,
                    }}
                ></div>
            </FmDrawer>
        </>
    );
};

export default BannerClient;
